export const FOOTER_CONTACT_ITEMS = Object.freeze([
  {
    type: 'email',
    label: 'CONTACT US',
    value: 'snorose1906@gmail.com',
  },
  {
    type: 'bank',
    label: '숙명여대 후원하기',
    value: '카카오뱅크 3333-31-8162062',
    accountHolder: '(예금주: 김*지)',
  },
]);

export const FOOTER_MENUS = Object.freeze([
  {
    to: '/my-page/service-policy',
    title: '서비스 이용 약관',
  },
  {
    to: '/my-page/privacy-policy',
    title: '개인정보 처리방침',
  },
  {
    to: 'https://www.notion.so/snorose/1147ef0aa3bf8039add2e00a4edd0eb4',
    title: '배너 및 광고 문의',
  },
]);

export const FOOTER_SNS_LINKS = Object.freeze([
  {
    id: 'instagram',
    iconId: 'instagram',
    to: 'https://www.instagram.com/snorose1906/',
  },
]);
